var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentCommunity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.906,
    height: 25.1,
    viewBox: "0 0 24.906 25.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15539",
    "data-name": "Path 15539",
    d: "M105.866,13.332H89.758a4.354,4.354,0,0,0-4.349,4.349V28.238a4.354,4.354,0,0,0,4.349,4.349h1.9v3.33a2.367,2.367,0,0,0,1.314,2.145,2.416,2.416,0,0,0,1.1.27,2.385,2.385,0,0,0,1.407-.466l7.276-5.279h3.113a4.354,4.354,0,0,0,4.349-4.349V17.681a4.354,4.354,0,0,0-4.35-4.349Zm2.69,14.906a2.693,2.693,0,0,1-2.69,2.69h-3.382a.829.829,0,0,0-.487.158L94.5,36.523a.748.748,0,0,1-1.187-.605v-4.16a.83.83,0,0,0-.83-.83H89.758a2.693,2.693,0,0,1-2.69-2.69V17.681a2.693,2.693,0,0,1,2.69-2.69h16.108a2.693,2.693,0,0,1,2.69,2.69V28.238Z",
    transform: "translate(-85.359 -13.282)",
    stroke: "#000",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentCommunity);
export default __webpack_public_path__ + "static/media/CommentCommunity.8c53a747e141195b08b20735fe9fbc01.svg";
export { ForwardRef as ReactComponent };